
import axios from 'axios';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
// const apiUrl = process.env.REACT_APP_API_URL;

export const fetchPurposeApi = async (url: string) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/Purpose/GetAllPurpose`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching purposes from:", `${url}/Purpose/GetAllPurpose`, error);
    throw error;
  }
}